module.exports = __webpack_public_path__ + "static/media/icon-circle.561dc9ba.svg";